import type { MenuProps } from 'antd';

export enum MoreOperateKey {
  MEET = 'meet',
  MESSAGES = 'messages',
  PARTICIPANTS = 'participants',
  FULL_SCREEN = 'fullScreen',
  SETTING = 'setting',
}

export interface MoreOperateProps {
  children: ReactNode;
  onClick: MenuProps['onClick'];
}
